import { useContext } from 'react';

import { AuthenticationContext } from '../../../AuthenticationContext';


export function useHasPermission() {
    const { user } = useContext(AuthenticationContext);

    return {
        hasAdminPermission: user?.frameworkRole === 'admin'
    };
}
